import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Contract.UploadSignedDocument.IRequest;
type Response = Api.Core.Contract.UploadSignedDocument.IResponse;
type Headers = Api.Core.Contract.UploadSignedDocument.IHeaders;
const url = '/api/Sales/Contract/UploadSignedDocument/:envelopeId';
export default async function contractUploadSignedDocumentApi(params: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
  });
}
